import { Injectable } from '@angular/core';
import { AmdocsAppsyncClientService } from 'amdocs-auth-package';
import { Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { CONSTANTS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private newsData: INews[] = [];
  public newAlert = false;

  constructor(
    private appSyncClient: AmdocsAppsyncClientService) {}

  public getNewsFromServer(): Observable<boolean> {
    const query = `
      query GetNews {
        news {
          display_date
          link_to_article
          main_picture
          number
          description
          short_description
        }
      }`;
    return this.appSyncClient.call(query, 'GetNews');
  }

  getMailLink() {
        const query = `
        query getUserMondayMailLink {
          mondayMail {
            userMondayMailLink
          }
        }
      `
      return this.appSyncClient.call(query, 'getUserMondayMailLink');
  }


  getNews(): Observable<INews[]> {
    if (this.newsData.length) {
      return of(this.newsData);
    } else {
      return this.getNewsFromServer().pipe(
        mergeMap((res: any) => {
          this.newsData = res.news;
          this.newAlert = this.checkNewsAlertStatus();
          return of(this.newsData);
        }),
        catchError( err => of(this.newsData)));
    }
  }

  public markNewsAsRead(): void {
    // get old storedNews
    const storedNews = JSON.parse(localStorage.getItem(CONSTANTS.STORAGE_KEYS.NEWS)) || {};

    this.newsData.forEach((newsItem: INews) => {
      // 2020-04-02 12:53:20
      const itemDate = newsItem.display_date.substring(0, 10);

      // check if date exist in storedNews
      if (!storedNews[itemDate]) {
        storedNews[itemDate] = [];
        storedNews[itemDate].push(newsItem.number);
      } else if (storedNews[itemDate].join(' ').indexOf(newsItem.number) === -1){
        storedNews[itemDate].push(newsItem.number);
      }
    });

    // filter oldDate
    Object.keys(storedNews).forEach((date) => {
      const today = new Date();
      const twoWeeksAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 365);
      const articleDates = new Date(date);
      if (articleDates.getTime() < twoWeeksAgo.getTime()) {
        delete storedNews[date];
      }
    });

    localStorage.setItem(CONSTANTS.STORAGE_KEYS.NEWS, JSON.stringify(storedNews));
    this.newAlert = false;
  }

  /**
   * @description:
   * check if has news that not exist in stored data
   */

  private checkNewsAlertStatus(): boolean {
    const storedNews = JSON.parse(localStorage.getItem(CONSTANTS.STORAGE_KEYS.NEWS));
    if (storedNews) {
      return !!this.newsData.filter( (newsItem: INews) => {
        const itemDate = newsItem.display_date.substring(0, 10);
        const check = !storedNews[itemDate] || (storedNews[itemDate] && storedNews[itemDate].join(' ').indexOf(newsItem.number.toString()) === -1);
        return !!check;
      }).length;
    } else {
      return true;
    }
  }
}

export interface INews {
  display_date: string;
  link_to_article: string;
  main_picture: string;
  number: boolean;
  short_description: string;
  description: string;
}
